export function inflection(size, one, twofour, five) {
    if (size == 1) {
        return one;
    }
    else if (size > 1 && size < 5) {
        return twofour;
    }
    else
        return five;
}
